import { IEnvironment } from './environment';

export const environmentProd: IEnvironment = {
    environments: [
        {
            name: 'Mainnet',
            url: 'https://api.cupofsugar.io',
        },
    ],
    isLoggerEnabled: false,
};
